// Añadir productos a la presentación
import React, { useEffect, useState } from 'react'
import { Redirect, useHistory, useParams, withRouter } from 'react-router-dom'
import {  presentationsApi } from '../../api/presentationsApi'
import { routes } from '../../constantes/routes'
import NodesCataloguePresentacion from './NodesCataloguePresentacion'

const AddProductToThePresentationFromTheCatalog = () => {
    const { id } = useParams() 
    const history = useHistory()

    const [existPresentation, setExistPresentation] = useState(true)

    useEffect(() => {
        getPresentationById(id) 
    }, [id])

   
    const getPresentationById = async (getPresentationById) => {
        try {
            const response = await presentationsApi.getPresentationById(getPresentationById)
            if (response.data.id_Presentacion) {
                setExistPresentation(true)
            }
        } catch (error) {
            setExistPresentation(false)
            history.push(routes.PRESENTATION)
        }
    }   

    return (
        <>
            { 
                existPresentation ?
                <div className="products"> 
                    <NodesCataloguePresentacion idPresentation={id}/> 
                </div>
                : <Redirect to={routes.PRESENTATION} />
            }
         </>
    )
}

export default withRouter(AddProductToThePresentationFromTheCatalog)